module.exports = __webpack_public_path__ + "img/exchange-shortcut.96814c80.svg";